import React from "react";
import styles from "../styles/globalStyles.module.css";
import { AccessTime } from "@mui/icons-material";
import moment from "moment";
import dummyImage from "../../src/portals/customer/assets/fortmatic_replace.png";
import pendingIcon from "../../src/portals/customer/assets/pendingIcon.png";
import paymentSuccessIcon from "../../src/portals/customer/assets/paymentCompleted.png";
import paymentPendingIcon from "../../src/portals/customer/assets/paymentPending.png";
import paymentRejectIcon from "../../src/portals/customer/assets/paymentFailed.png";
import topupFailedIcon from "../../src/portals/customer/assets/topupFailed.png";
import topupPendingIcon from "../../src/portals/customer/assets/topupPending.png";
import topupSuccessIcon from "../../src/portals/customer/assets/topupSuccess.png";
import orderProcessIcon from "../../src/portals/customer/assets/topupSuccess.png";
// import orderShippedIcon from "../assets/45.png";
import orderShippedIcon from "../../src/portals/customer/assets/delivered.png";

export default function NewNotifications({
  notifications,
  yesterdayNotifications,
}) {

  return (
    <div style={{ position: "relative" }}>
      {notifications?.length > 0 ? (
        <div
          style={{
            height: `${yesterdayNotifications?.length > 0 ? "400px" : "auto"}`,
            overflowY: "scroll",
          }}
          className="notification"
        >
          <h5 style={{ color: "gray", margin: "10px 20px" }}>NEW</h5>
          {notifications?.map((notification) => (
            <div className={styles.newNotificationBox} key={notification._id}>
              <div style={{ display: "flex" }}>
                <img
                  src={
                    notification?.notification_for === "order_process"
                      ? pendingIcon
                      : notification?.notification_for === "payment_success"
                      ? paymentSuccessIcon
                      : notification?.notification_for === "payment_pending"
                      ? paymentPendingIcon
                      : notification?.notification_for === "payment_reject"
                      ? paymentRejectIcon
                      : notification?.notification_for === "topup_reject"
                      ? topupFailedIcon
                      : notification?.notification_for === "topup_pending"
                      ? topupPendingIcon
                      : notification?.notification_for === "topup_success"
                      ? topupSuccessIcon
                      : notification?.notification_for === "order_process"
                      ? orderProcessIcon
                      : notification?.notification_for === "order_shipped"
                      ? orderShippedIcon
                      : dummyImage
                  }
                  alt="img"
                  style={{
                    width: "40px",
                    height: "40px",
                    borderRadius: "50%",
                    marginRight: 20,
                  }}
                />
                <div>
                  <h6
                    style={{
                      fontWeight: 600,
                      lineHeight: "1.5",
                      fontSize: "0.88",
                      margin: 0,
                    }}
                  >
                    {notification.title}{" "}
                    <span style={{ color: "gray", fontWeight: 300 }}>
                      {notification?.text}
                    </span>
                  </h6>
                  <div className="flexbox">
                    <h6
                      style={{
                        color: "rgb(145, 158, 171",
                        fontWeight: 400,
                        fontSize: "0.75rem",
                        marginTop: "5px",
                        marginBottom: 0,
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      {" "}
                      <AccessTime
                        style={{ fontSize: "0.75rem", marginRight: 5 }}
                      />
                      {moment(notification?.createdAt)
                        .startOf("minute")
                        .fromNow()}
                    </h6>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      ) : yesterdayNotifications?.length > 0 ? (
        <div>
          <h5 style={{ color: "gray", margin: "10px 20px" }}>YESTERDAY</h5>
          {yesterdayNotifications?.map((notification) => (
            <div
              className={styles.newNotificationBox}
              style={{ background: "#fff" }}
              key={notification.id}
            >
              <div style={{ display: "flex" }}>
                <img
                  src={
                    notification?.notification_for === "payment_success"
                      ? paymentSuccessIcon
                      : notification?.notification_for === "payment_pending"
                      ? paymentPendingIcon
                      : notification?.notification_for === "payment_reject"
                      ? paymentRejectIcon
                      : notification?.notification_for === "topup_reject"
                      ? topupFailedIcon
                      : notification?.notification_for === "topup_pending"
                      ? topupPendingIcon
                      : notification?.notification_for === "topup_success"
                      ? topupSuccessIcon
                      : notification?.notification_for === "order_process"
                      ? orderProcessIcon
                      : notification?.notification_for === "order_shipped"
                      ? orderShippedIcon
                      : dummyImage
                  }
                  alt="img"
                  style={{
                    width: "40px",
                    height: "40px",
                    borderRadius: "50%",
                    marginRight: 20,
                  }}
                />
                <div>
                  <h6
                    style={{
                      fontWeight: 600,
                      lineHeight: "1.5",
                      fontSize: "0.88",
                      margin: 0,
                    }}
                  >
                    {/* {notification.title}{" "} */}
                    <span style={{ color: "gray", fontWeight: 300 }}>
                      {notification?.text}
                    </span>
                  </h6>
                  <div className="flexbox">
                    <h6
                      style={{
                        color: "rgb(145, 158, 171",
                        fontWeight: 400,
                        fontSize: "0.75rem",
                        marginTop: "5px",
                        marginBottom: 0,
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      {" "}
                      <AccessTime
                        style={{ fontSize: "0.75rem", marginRight: 5 }}
                      />
                      {moment(notification?.createdAt)
                        .startOf("minute")
                        .fromNow()}
                    </h6>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      ) : (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            height: "300px",
            fontSize: "24px",
            color: "lightgray",
          }}
        >
          You have no notifications
        </div>
      )}

      {/* before that */}
    </div>
  );
}
